const config = {
  production: {
    SERVER_URL: 'https://api.giglifepro.com',
    SENDBIRD_APP_ID: '0B5BB8B3-FCE5-4D17-8816-44D33A6A0C59',
    STRIPE_PUB_KEY: 'pk_live_SoWq5YyP7r7HjBKrJAv5nmNp00xQpkWaCM',
    ANALYTICS: 'G-YW0R7VXFZZ',
    FB_PIXEL: '2941364236136088',
    LINKEDIN_TAG_ID: '3409676',
    LINKEDIN_FREE_TIER: '7875212',
    WEB_URL: 'https://giglifepro.com',
    RECAPTCHA_SITE_KEY: '6LdE4l0sAAAAAEqaxqfO5UA1SovNgEK0T-DCR4vp',
    PLATFORM_MAINTENANCE_START_TIME: "2026-04-06T00:00:00+08:00",
    PLATFORM_MAINTENANCE_END_TIME: "2026-04-13T09:59:59+08:00",
  },
  staging: {
    SERVER_URL: 'https://staging-api.giglifepro.com',
    SENDBIRD_APP_ID: '5E948E42-42F6-42DF-B5C3-9A9807F894D7',
    STRIPE_PUB_KEY: 'pk_test_NR64diXFxosquGmbFV3gJbpY00XKlQW0Pp',
    WEB_URL: 'https://staging.giglifepro.com',
    RECAPTCHA_SITE_KEY: '6LfEzlosAAAAAO0MBA2gzOtMnVVrnJ7-3JaLIuZL',
    PLATFORM_MAINTENANCE_START_TIME: "2026-04-06T00:00:00+08:00",
    PLATFORM_MAINTENANCE_END_TIME: "2026-04-12T23:59:59+08:00",
  },
  development: {
    SERVER_URL: 'https://dev-api-giglifepro.vinova.sg/',
    SENDBIRD_APP_ID: '5E948E42-42F6-42DF-B5C3-9A9807F894D7',
    STRIPE_PUB_KEY:
      'pk_test_51Q2kkYKywYe83pSEoKHDGtLuOMc8Ctaqaly8uIbVqy7SuxLJvnjzlTTsML7LVmyhWKiXOzFCEPIvcRH5KakFEVSv009GSKQsIZ',
    ANALYTICS: 'G-H4SBXJLJT7',
    WEB_URL: 'https://dev-giglifepro.vinova.sg/',
    RECAPTCHA_SITE_KEY: '6LfEzlosAAAAAO0MBA2gzOtMnVVrnJ7-3JaLIuZL',
    PLATFORM_MAINTENANCE_START_TIME: "2026-04-06T00:00:00+08:00",
    PLATFORM_MAINTENANCE_END_TIME: "2026-04-12T23:59:59+08:00",
  },
};

const { NODE_ENV } = process.env;

export const isProduction = NODE_ENV === 'production';
export const isDevelop = NODE_ENV === 'development';
export const isStaging = NODE_ENV === "staging";

export default config[NODE_ENV];
